// /bootcampy/klienti — Klientky bootcampu jako samostatná stránka (16.9.2026).
//
// Do 16.9.2026 to byla záložka uvnitř Běhů. Bootcamps je teď vlastní sekce
// menu, takže seznam lidí má svoji stránku a svoji hlavičku. Samotný seznam
// se nezměnil, jen se k němu přidala hlavička a obal stránky.
//
// Právo: owner, manažer, CSM a head coach vidí všechny. Trenér se sem
// z menu nedostane, jeho agenda je docházka u jeho běhu.

import React from "react";
import { Users } from "lucide-react";
import GradientHeader from "../../components/GradientHeader.jsx";
import { Stranka } from "../../components/ui.jsx";
import KlientiBC from "./KlientiBC.jsx";

export default function BootcampKlientiStranka() {
  return (
    <Stranka>
      <GradientHeader
        title="Klientky"
        icon={Users}
        napoveda="Lidé, kteří si koupili bootcamp. Vedou se odděleně od klientek koučinku, protože jméno, e-mail i telefon jsou ty z nákupu bootcampu. Kdo jede dva běhy, je tu jednou."
      />
      <KlientiBC />
    </Stranka>
  );
}
